

    /**
     * Get current time in miliseconds
     */
    function now(){
        // yes, we defer the work to another function to allow mocking it
        // during the tests
        return now.get();
    }

    now.get = (typeof Date.now === 'function')? Date.now : function(){
        return +(new Date());
    };

    module.exports = now;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/time/now.js
// module id = 914
// module chunks = 1